import type { Placement } from '../../../constants/recommendations';

export type ListingsAPIRecommendationPlacement = Placement.SimilarProducts | Placement.SameSeller2;
// To be added at a later date, these placements existed with Algonomy but are not in scope for TP-1665
// see https://notonthehighstreet.atlassian.net/wiki/spaces/KC2024/pages/5461606401/Moving+recommendations+to+Vertex
// | Placement.ActiveProducts
// | Placement.RecentlyViewed;

export class UnreachableError extends Error {
  constructor(val: never, message: string) {
    super(`TypeScript thought we could never end up here\n${message}`);
  }
}
